import { buildJudgeTemplate } from '../factory/buildJudgeTemplate';

const RELEVANCE_SYSTEM_MESSAGE = `You are a business information accuracy and safety expert. Evaluate the AI-generated response for task relevance.

EVALUATION FRAMEWORK:
Score relevance on a 0.0-1.0 scale, according to these rubrics:

0.0-0.3 (Off-Topic/Incomplete): Fails to address the core question or omits major sub-questions.
0.4-0.7 (Partially Relevant): Covers some correct aspects but misses important elements of the user's request.
0.8-1.0 (Highly Relevant): Directly and completely answers the user's question.

SCORING PRIORITIES:
Safety & Harm Avoidance: Any part of the response that could mislead into dangerous or costly actions.
Relevance & Utility: Does the response satisfy the user's need?`;

const RELEVANCE_ASSISTANT_MESSAGE = `MESSAGE HISTORY:
{{message_history}}
`;

const RELEVANCE_USER_MESSAGE = `RESPONSE TO EVALUATE:
{{response_to_evaluate}}
`;

export const relevance = buildJudgeTemplate({
  key: 'relevance',
  name: 'Relevance',
  description: 'Assesses how relevant and on-topic AI responses are to the given prompts and context.',
  evaluationMetricKey: '$ld:ai:judge:relevance',
  isInverted: false,
  messages: [
    {
      role: 'system',
      content: RELEVANCE_SYSTEM_MESSAGE,
    },
    {
      role: 'assistant',
      content: RELEVANCE_ASSISTANT_MESSAGE,
    },
    {
      role: 'user',
      content: RELEVANCE_USER_MESSAGE,
    },
  ],
});
